// extracted by mini-css-extract-plugin
export default {"container":"BackToTop_container__JT94x","container0":"BackToTop_container0__GDuMJ","active":"BackToTop_active__mDEAX"};